// extracted by mini-css-extract-plugin
export default {"filterContainer":"styles-scoped__filterContainer--IOA7j"};